function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#e2e2e2",
  d: "M107.5,69.4c0-26.6-21.6-48.2-48.2-48.2c-26.6,0-48.2,21.6-48.2,48.2c0,8.4,2.2,16.3,5.9,23.2h84.6 C105.3,85.7,107.5,77.8,107.5,69.4z"
}))));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#e2e2e2",
  d: "M107.1,26.4l-0.3,0.3c-0.8,0.8-2.1,0.8-3,0l-0.3-0.3c-0.3-0.3-0.9-0.4-1.2-0.1c-0.4,0.3-0.4,0.9-0.1,1.3 l0.3,0.3c0.8,0.8,0.8,2.1,0,3l-0.3,0.3c-0.3,0.3-0.4,0.9-0.1,1.2c0.3,0.4,0.9,0.4,1.3,0.1l0.3-0.3c0.8-0.8,2.1-0.8,3,0l0.3,0.3 c0.3,0.3,0.9,0.4,1.2,0.1c0.4-0.3,0.4-0.9,0.1-1.3l-0.3-0.3c-0.8-0.8-0.8-2.1,0-3l0.3-0.3c0.4-0.4,0.3-1-0.1-1.3 C108,26,107.5,26.1,107.1,26.4z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#e2e2e2",
  d: "M45.6,13.6l-0.2,0.2c-0.5,0.5-1.3,0.5-1.8,0l-0.2-0.2c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.2-0.3,0.6,0,0.8l0.2,0.2 c0.5,0.5,0.5,1.3,0,1.8l-0.2,0.2c-0.2,0.2-0.2,0.5-0.1,0.7c0.2,0.2,0.6,0.3,0.8,0l0.2-0.2c0.5-0.5,1.3-0.5,1.8,0l0.2,0.2 c0.2,0.2,0.5,0.2,0.7,0.1c0.2-0.2,0.3-0.6,0-0.8l-0.2-0.2c-0.5-0.5-0.5-1.3,0-1.8l0.2-0.2c0.2-0.2,0.2-0.6,0-0.8 C46.2,13.4,45.8,13.4,45.6,13.6z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#e2e2e2",
  d: "M22.4,60l-0.2,0.2c-0.5,0.5-1.3,0.5-1.8,0L20.2,60c-0.2-0.2-0.5-0.2-0.7-0.1c-0.2,0.2-0.3,0.6,0,0.8l0.2,0.2 c0.5,0.5,0.5,1.3,0,1.8l-0.2,0.2c-0.2,0.2-0.2,0.5-0.1,0.7c0.2,0.2,0.6,0.3,0.8,0l0.2-0.2c0.5-0.5,1.3-0.5,1.8,0l0.2,0.2 c0.2,0.2,0.5,0.2,0.7,0.1c0.2-0.2,0.3-0.6,0-0.8L23,62.8c-0.5-0.5-0.5-1.3,0-1.8l0.2-0.2c0.2-0.2,0.2-0.6,0-0.8 C22.9,59.8,22.6,59.8,22.4,60z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M43.5,33.9l-0.2,0.2c-0.7,0.7-1.8,0.7-2.5,0l-0.2-0.2c-0.3-0.3-0.7-0.3-1-0.1c-0.3,0.3-0.4,0.8-0.1,1.1l0.3,0.3 c0.7,0.7,0.7,1.8,0,2.5L39.4,38c-0.3,0.3-0.3,0.7-0.1,1c0.3,0.3,0.8,0.4,1.1,0.1l0.3-0.3c0.7-0.7,1.8-0.7,2.5,0l0.2,0.2 c0.3,0.3,0.7,0.3,1,0.1c0.3-0.3,0.4-0.8,0.1-1.1l-0.3-0.3c-0.7-0.7-0.7-1.8,0-2.5l0.3-0.3c0.3-0.3,0.3-0.8-0.1-1.1 C44.2,33.6,43.8,33.6,43.5,33.9z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M98.4,56.9l-0.2,0.2c-0.6,0.6-1.7,0.6-2.3,0l-0.2-0.2c-0.3-0.3-0.7-0.3-0.9-0.1c-0.3,0.3-0.3,0.7,0,1l0.2,0.2 c0.6,0.6,0.6,1.7,0,2.3l-0.2,0.2c-0.3,0.3-0.3,0.7-0.1,0.9c0.3,0.3,0.7,0.3,1,0l0.2-0.2c0.6-0.6,1.7-0.6,2.3,0l0.2,0.2 c0.3,0.3,0.7,0.3,0.9,0.1c0.3-0.3,0.3-0.7,0-1l-0.2-0.2c-0.6-0.6-0.6-1.7,0-2.3l0.2-0.2c0.3-0.3,0.3-0.7,0-1 C99,56.7,98.6,56.7,98.4,56.9z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#e2e2e2",
  d: "M10.9,37.1l-0.3,0.3c-0.8,0.8-2.2,0.8-3,0l-0.3-0.3C6.9,36.7,6.4,36.7,6,37c-0.4,0.3-0.4,1-0.1,1.3l0.3,0.3 c0.8,0.8,0.8,2.2,0,3L6,41.9c-0.3,0.3-0.4,0.9-0.1,1.2c0.3,0.4,1,0.4,1.3,0.1l0.3-0.3c0.8-0.8,2.2-0.8,3,0l0.3,0.3 c0.3,0.3,0.9,0.4,1.2,0.1c0.4-0.3,0.4-1,0.1-1.3l-0.3-0.3c-0.8-0.8-0.8-2.2,0-3l0.3-0.3c0.4-0.4,0.3-1-0.1-1.3 C11.8,36.7,11.2,36.7,10.9,37.1z"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 31.3,
  y: 47.3,
  width: 53.3,
  height: 20.3,
  fill: "#f4f4f4"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polyline", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "62.8,46.4 87.5,46.4 87.5,70.3 31,70.3 31,46.4 54.2,46.4 "
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polyline", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "31,92.6 31,74.6 87.5,74.6 87.5,92.6 "
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "88.6,74.6 29.9,74.6 28.7,70.3 89.8,70.3 "
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polyline", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "52.3,38.5 58.5,32.3 64.7,38.5 "
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#d7d7d7",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "63.6,49.4 58.5,52.2 53.4,49.4 53.4,41.9 63.6,41.9 "
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#ffffff",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  cx: 58.5,
  cy: 46.8,
  r: 1.9
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  x1: 34.1,
  y1: 79.3,
  x2: 53.3,
  y2: 79.3,
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 42.4,
  y: 79.3,
  width: 11.3,
  height: 13.3,
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 42.4,
  y1: 79.3,
  x2: 53.6,
  y2: 92.6
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 53.6,
  y1: 79.3,
  x2: 42.2,
  y2: 92.6
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 62.1,
  y1: 79.3,
  x2: 81.5,
  y2: 79.3
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 70.6,
  y: 79.3,
  width: 11.3,
  height: 13.3,
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 70.6,
  y1: 79.3,
  x2: 81.9,
  y2: 92.6
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  className: "st3",
  x1: 81.9,
  y1: 79.3,
  x2: 70.6,
  y2: 92.6
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  points: "65.5,41.9 51.5,41.9 51.2,38.5 65.8,38.5 "
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 7.3,
  y1: 92.6,
  x2: 111.3,
  y2: 92.6
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 31.3,
  y1: 105.2,
  x2: 79.2,
  y2: 105.2
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 84.7,
  y1: 105.2,
  x2: 87.2,
  y2: 105.2
}));

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 14.3,
  y1: 98.9,
  x2: 62.2,
  y2: 98.9
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 67.6,
  y1: 98.9,
  x2: 70.2,
  y2: 98.9
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#aeaeae",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  x1: 74.9,
  y1: 98.9,
  x2: 104.2,
  y2: 98.9
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117 117",
    style: {
      "enableBackground": "new 0 0 117 117"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default __webpack_public_path__ + "static/media/offline.068f0857.svg";
export { SvgComponent as ReactComponent };